import './bindings/resAreaLabelBinding';
import './bindings/restextBinding';
import './bindings/resplaceHolderBinding';

function CommonBindings() {

  // ----------------------------------------------------------------------------------------------------
  // This module exists to load up all the binding modules therefore registering them with Knockout.
  // ----------------------------------------------------------------------------------------------------

  var self = this;

  // Initialise function added for future support
  self.init = function () {
  };
}

export default new CommonBindings();
